<!-- Do not use localize pipe here as it won't work with shareable reports -->
<div
    class="agpr-top-terms-chart-container"
    [agprLoading]="loading"
    [attr.aria-label]="'Please switch to focus mode and use spacebar to select the term or use enter key to open the mentions link.'"
>
    <h5
        *ngIf="header"
        class="agpr-top-terms-chart-metric-list-heading"
    >
        {{ header | titlecase }}
    </h5>

    <ng-container *ngIf="data?.length; else emptyContainer">
        <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
        <div
            *ngFor="let datum of data"
            class="agpr-top-terms-chart-cardChart"
            [ngClass]="{
                'active': (datum.id === currentTerm?.id) && focusable
            }"
            [ngStyle]="{ background: (datum.id === currentTerm?.id) && focusable ? accentColor : null }"
            (click)="selectTerm(datum, $event)"
            [agprChartTooltipLabel]="datum.label"
            [tooltipDataText]="datum.tooltipDataText"
            [tooltipLinkText]="datum.tooltipLinkText"
            [tooltipLinkUrl]="datum.viewMentionUrl"
            [tooltipDisabled]="hideTooltip"
            (linkClicked)="handleLinkClick(datum)"
            (keyup.space)="selectTerm(datum, $event)"
            agprChartTooltip
        >
            <div
                class="agpr-top-terms-chart-cardChart-bubble"
                [ngStyle]="{ background: (datum.id === currentTerm?.id) && focusable ? agprWhite : accentColor }"
            >
            </div>
            <!-- set aria-hidden="true" so SR won't announced datum label and count twice (from tooltip and here) -->
            <div class="agpr-top-terms-chart-cardChart-text">
                <span aria-hidden="true">{{ datum.label }}</span>
            </div>
            <div
                *ngIf="chartMetric === chartMetricsEnum.ave && chartOptions.currencyCode"
                class="agpr-top-terms-chart-cardChart-value"
                aria-hidden="true"
            >
                {{ (datum.count | number | AppendCurrencyCode:  chartOptions?.currencyCode) }}
            </div>
            <div
                *ngIf="!hideValue && (chartMetric !== chartMetricsEnum.ave)"
                class="agpr-top-terms-chart-cardChart-value"
                aria-hidden="true"
            >
                {{ (datum.count | number) }}
            </div>
        </div>
        <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
    </ng-container>
</div>

<ng-template #emptyContainer>
    <agpr-message
        [severity]="messageSeverities.noContent"
        [style]="agprComponentStyle.social"
    >
        {{ noContentMessage }}
    </agpr-message>
</ng-template>

